import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function PalAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "18%"}}>
                                        1 mese
                                    </th>
                                    <th scope="col" style={{width: "18%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "18%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "18%"}}>
                                        Stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Open</th>
                                    <td>75 €</td>
                                    <td>202 €</td>
                                    <td>360 €</td>
                                    <td>577 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Open Mattino<br/><span style={{fontSize: "12px"}}>(fino alle 15)</span>  </th>
                                    <td>60 €</td>
                                    <td>169 €</td>
                                    <td>300 €</td>
                                    <td>462 €</td>
                                </tr>
                                <tr >
                                    <th scope="row">Universitari <br/> </th>
                                    <td>56 €</td>
                                    <td>162 €</td>
                                    <td>288 €</td>
                                    <td>433 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Universitari Mattino<br/><span style={{fontSize: "12px"}}>(fino alle 15)</span>  </th>
                                    <td>50 €</td>
                                    <td>147 €</td>
                                    <td>262 €</td>
                                    <td>390 €</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                        </div>
                        <br/>
                        <AllertIscrizione />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PalAccordionPrezzi